const searchToggler = document.querySelector('.search-toggler');
const searchContainer = document.querySelector('div.header-search')
const searchInput = searchContainer.querySelector('input');
const searchOverlay = document.createElement('div');

searchOverlay.classList.add('search-overlay');
document.querySelector('.wp-site-blocks').appendChild(searchOverlay);

searchToggler.addEventListener('click', (e) => {
    e.preventDefault();

    searchContainer.classList.toggle('open');
    document.body.classList.toggle('search-open');

    if (searchContainer.classList.contains('open')) {
        searchInput.focus();
    }
});

searchInput.type = 'text';
searchInput.autocomplete = 'off';

searchInput.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
        searchContainer.classList.remove('open');
        document.body.classList.remove('search-open');
    }
});

searchOverlay.addEventListener('click', () => {
    searchContainer.classList.remove('open');
    document.body.classList.remove('search-open');
});